export const FETCH_COURSES = "FETCH_COURSES";
export const FETCH_COURSESDETAIL = "FETCH_COURSESDETAIL";
export const FETCH_CREDENTIALS = "FETCH_CREDENTIALS";
export const COURSES_SEARCH = "COURSES_SEARCH ";
export const SET_INDEX = "SET_INDEX";
export const KEY_WORDS = "KEY_WORDS ";
export const FETCH_CATEGORIES = "FETCH_CATEGORIES";
export const FETCH_LIST_CATEGORIES = "FETCH_LIST_CATEGORIES";
export const FETCH_LOCATION = "FETCH_LOCATION";
export const KEY_WORDS_JOBS = "KEY_WORDS_JOBS";
export const SHOW_POPUP = "SHOW_POPUP";
export const INFO_USER = "INFO_USER";
export const DISABLE_ON_OFF = "DISABLE_ON_OFF";
export const SET_AVATAR = "SET_AVATAR";
export const AVATAR_LIST = "AVATAR_LIST";
export const CART_ON_OFF = "CART_ON_OFF";
export const FETCH_CARTS = "FETCH_CARTS";
export const ADD_CARTS = "ADD_CARTS";
export const REMOVE_CARTS = "REMOVE_CARTS";
export const CHOOSE_CARTS_ITEM = "CHOOSE_CARTS_ITEM";
export const NOT_CHOOSE_CARTS_ITEM = "NOT_CHOOSE_CARTS_ITEM";
export const SET_CHOOSE_CART_ITEM = "SET_CHOOSE_CART_ITEM";
export const LIST_CHOOSE_CART = "LIST_CHOOSE_CART";
export const FETCH_REGISTRATED_COURSES = "FETCH_REGISTRATED_COURSES";
export const ADD_REGISTRATION_COURSES = "ADD_REGISTRATION_COURSES";
export const FETCH_WAITING_COMFIRM_REGISTRANTION =
  "FETCH_WAITING_COMFIRM_REGISTRANTION";
export const FETCH_COMFIRMED_REGISTERED = "FETCH_COMFIRMED_REGISTERED";

// responsive
export const FETCH_SIZE_SCREEN = "FETCH_SIZE_SCREEN";
export const FETCH_COURSES_PAGINATION = "FETCH_COURSES_PAGINATION";
export const SIDEBAR = "SIDEBAR";
export const MODAL_TOGGLE = "MODAL_TOGGLE";
export const COURSE_WILL_UPDATE = "COURSE_WILL_UPDATE";
export const KEY_WORDS_ADMIN_SEARCH = "KEY_WORDS_ADMIN_SEARCH";
export const SET_THEME = "SET_THEME";
